/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicEmojisQueryResponse, GetApiPublicEmojisQueryParams } from "../entities/GetApiPublicEmojis";

function getGetApiPublicEmojisUrl() {
  const res = { method: 'GET', url: `/api/public/emojis` as const }
  return res
}

/**
 * @description Получить список эмодзи для выбора имени клиента
 * @summary Получить доступные эмодзи
 * {@link /api/public/emojis}
 */
export async function getApiPublicEmojis(params?: GetApiPublicEmojisQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiPublicEmojisQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetApiPublicEmojisUrl().url.toString(), params, ... requestConfig })
  return res.data
}